export default {
      id: "cushion_brill-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "icons.svg#cushion_brill",
      toString: function () {
        return this.url;
      }
    }